import { useEffect, useMemo, useState } from "react";
import { usePostSalesOrderListMutation } from "../../../../../store/api/salesorderapi";
import ActionButtonDropdown from "../../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../../Core/Layout/ListLayout";
import Table from "../../../../../Core/Table/Table";
import Tabs from "../../../../../Components/Tabs";
import ConfigureColumnsNew from "../../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ExportCSV from '../../../../../Core/Export/ExportCSV';
import ListFilters from "../../../../../Core/ListFilters/ListFilters";
import useCustomNavigate from "../../../../../Hook/useCustomNavigate";
import { useDeleteDocMutation } from "../../../../../store/api/globalapi";
import DelConfirmPopup from '../../../../../Components/Popup/DelConfirmPopup '
import useScreenHeight from "../../../../../utils/useScreenHeight";
const Lpntable = () => {
    const navigate = useCustomNavigate();
    const { screenHeight, screenScaling,pageSize } = useScreenHeight();

    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [salesData, setSalesData] = useState({ sales_orders: [], total_no_of_records: 0 });
    const [salesDataApi] = usePostSalesOrderListMutation();
    const [showExportPopup, setShowExportPopup] = useState(false);
    const [showColumnConfig, setShowColumnConfig] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [deleteDoc] = useDeleteDocMutation();

    const filtersConfig = [
        { name: 'siNo', label: 'S. No', width: '7%', type: 'number' },
        { name: 'name', label: 'Sales Order No', width: '12%', type: 'text' },
        { name: 'customer', label: 'Customer', width: '13%', type: 'text' },
        { name: 'no_of_line', label: 'No. of Lines', type: 'number', width: '10%' },
        { name: 'total_qty', label: 'Total Quantity', type: 'number', width: '12%' },
        {
            name: 'net_total',
            label: 'Net Total',
            type: 'number',
            width: '10%'
        },
        {
            name: 'total_taxes',
            label: 'Total Taxes',
            type: 'number',
            width: '10%'
        },
        {
            name: 'grand_total',
            label: 'Grand Total',
            type: 'number',
            width: '10%'
        },
        {
            name: 'order_type',
            label: 'Order Type',
            type: 'text',
            width: '10%'
        },
        {
            name: 'place_of_supply',
            label: 'Place of Supply',
            type: 'text',
            width: '12%'
        },
        {
            name: 'billing_address',
            label: 'Billing Address',
            type: 'text',
            width: '15%'
        },
        {
            name: 'shipping_address',
            label: 'Shipping Address',
            type: 'text',
            width: '15%'
        },
        {
            name: 'mobile_number',
            label: 'Mobile Number',
            type: 'text',
            width: '12%'
        },
        {
            name: 'customer_gstin',
            label: 'Customer GSTIN',
            type: 'text',
            width: '12%'
        },
        {
            name: 'status',
            label: 'Status',
            width: '13.7%',
            type: 'select',
            options: [
                { value: 'Pick List Created', label: 'Pick List Created' },
                { value: 'To Deliver and Bill', label: 'To Deliver and Bill' },
                { value: 'Cancelled', label: 'Cancelled' },
                { value: 'Completely Picked', label: 'Completely Picked' },
                { value: 'Partially Picked', label: 'Partially Picked' },
                { value: 'Draft', label: 'Draft' },
                { value: 'On Hold', label: 'On Hold' },
                { value: 'To Bill', label: 'To Bill' },
                { value: 'Closed', label: 'Closed' }
            ]
        },
        {
            name: 'date_range',
            label: 'Date Range',
            type: 'date-range',
            width: '16%'
        }
    ];

    const [columnsConfig, setColumnsConfig] = useState(() => [
        {
            header: "S. No.",
            name: "S. No.",
            accessor: "siNo",
            width: '60px',
            cellRenderer: (row) => row.siNo,
            sortable: false,
            visible: true
        },
        {
            header: "Sales Order No",
            name: "Sales Order No",
            accessor: "name",
            width: '150px',
            sortable: true,
            visible: true
        },
        {
            header: "Customer",
            name: "Customer",
            accessor: "customer",
            width: '160px',
            sortable: true,
            visible: true
        },
        {
            header: "No. of Lines",
            name: "No. of Lines",
            accessor: "no_of_line",
            width: '120px',
            sortable: true,
            visible: true,
            sortFn: (a, b) => parseInt(a.no_of_line) - parseInt(b.no_of_line)
        },
        {
            header: "Total Quantity",
            name: "Total Quantity",
            accessor: "total_qty",
            width: '120px',
            sortable: true,
            visible: true,
            sortFn: (a, b) => parseInt(a.total_qty) - parseInt(b.total_qty)
        },
        {
            header: "Net Total",
            name: "Net Total",
            accessor: "net_total",
            width: '110px',
            sortable: true,
            visible: true
        },
        {
            header: "Total Taxes",
            name: "Total Taxes",
            accessor: "total_taxes",
            width: '110px',
            sortable: true,
            visible: true
        },
        {
            header: "Grand Total",
            name: "Grand Total",
            accessor: "grand_total",
            width: '110px',
            sortable: true,
            visible: true
        },
        {
            header: "Order Type",
            name: "Order Type",
            accessor: "order_type",
            width: '130px',
            sortable: true,
            visible: false
        },
        {
            header: "Place of Supply",
            name: "Place of Supply",
            accessor: "place_of_supply",
            width: '130px',
            sortable: true,
            visible: false
        },
        {
            header: "Billing Address",
            name: "Billing Address",
            accessor: "billing_address",
            width: '200px',
            sortable: true,
            visible: false
        },
        {
            header: "Shipping Address",
            name: "Shipping Address",
            accessor: "shipping_address",
            width: '200px',
            sortable: true,
            visible: false
        },
        {
            header: "Mobile No",
            name: "Mobile No",
            accessor: "mobile_number",
            width: '130px',
            sortable: true,
            visible: true
        },
        {
            header: "Customer GSTIN",
            name: "Customer GSTIN",
            accessor: "customer_gstin",
            width: '150px',
            sortable: true,
            visible: false
        },
        {
            header: "Status",
            name: "Status",
            accessor: "status",
            width: '180px',
            sortable: true,
            visible: true,
            cellRenderer: (row) => {
                const status = row.status;
                let color;

                switch (status) {
                    case 'Partially Picked':
                        color = '#F97316';
                        break;
                    case 'Draft':
                        color = '#6366F1';
                        break;
                    case 'On Hold':
                        color = '#F97316';
                        break;
                    case 'To Deliver and Bill':
                        color = '#6B21A8';
                        break;
                    case 'Pick List Created':
                        color = '#0E7490';
                        break;
                    case 'Completed':
                        color = '#65A30D';
                        break;
                    case 'To Bill':
                        color = '#D97706';
                        break;
                    case 'Completely Picked':
                        color = '#65A30D';
                        break;
                    case 'Cancelled':
                        color = '#EF4444';
                        break;
                    case 'Closed':
                        color = '#E11D48';
                        break;
                    default:
                        color = '#000000';
                }

                return (
                    <span
                        style={{
                            backgroundColor: `${color}1A`,
                            color,
                            padding: '4px 10px',
                            borderRadius: '9999px',
                            fontSize: '12px',
                            fontWeight: 500,
                            display: 'inline-block',
                            textTransform: 'capitalize',
                        }}
                    >
                        {status}
                    </span>
                );
            }
        },
        {
            header: "Date",
            name: "Date",
            accessor: "transaction_date",
            width: '100px',
            sortable: true,
            visible: true,
            sortFn: (a, b) => new Date(a.transaction_date) - new Date(b.transaction_date)
        },
        {
            header: "Action",
            name: "Action",
            width: '120px',
            sortable: false,
            visible: true,
            accessor: "action",
            cellRenderer: (row) => (
                <ActionButtonDropdown
                    id={row.name}
                    onView={() => handleView(row.name)}
                    onEdit={() => handleEdit(row.name)}
                    onDelete={() => handleDelete(row.name)}
                />
            )
        }
    ]);


    // Handle column configuration changes
    const handleSaveColumns = (selectedKeys, allFields) => {
        const updatedColumns = columnsConfig.map(column => {
            return {
                ...column,
                visible: selectedKeys.includes(column.accessor)
            };
        });
        setColumnsConfig(updatedColumns);
    };

    const visibleColumns = useMemo(() =>
        columnsConfig.filter(col => col.visible === true),
        [columnsConfig]
    );

    const defaultSelectedColumns = useMemo(() =>
        columnsConfig
            .filter(col => col.visible === true)
            .map(col => ({
                fieldname: col.accessor,
                label: col.name
            }))
            .filter(col => col.fieldname),
        [columnsConfig]
    );

    const handleView = (id) => {
        try {
            navigate(`/outbound/outbound-sales-order-view/`, { state: { salesorder: id } });
        } catch (err) {
            console.error("View failed:", err);
        }
    };

    const handleEdit = async (id) => {
        try {
            navigate(`/outbound/outbound-sales-order-edit/`, { state: { salesorder: id } });
        } catch (err) {
            console.error("Edit failed:", err);
        }
    };

    const [delPopupVisible, setDelPopupVisible] = useState(false);
    const [delSelectedId, setDelSelectedId] = useState(null);
    const [delmessage, setDelmessage] = useState();
    const [alredysubmitdata, setalredysubmitdata] = useState(false);
    const [delDone, setDeldelDone] = useState(false);



    const handleDelete = (id) => {
        setDelSelectedId(id);
        setDelPopupVisible(true);
        setalredysubmitdata(false)
        setDelmessage("Are you sure you want to delete this Sales Order?")
    };
    const delHandleCancel = () => {
        setDelPopupVisible(false);
        setDelSelectedId(null);
    };

    const delHandleConfirm = async () => {
        try {
            await deleteDoc({ doctype: "Sales Order", name: delSelectedId }).unwrap();
           
            setDelmessage(`Sales Order ${delSelectedId} deleted  successfully!`)
            setDeldelDone(true)
            setTimeout(() => {
                setDelPopupVisible(false);
                setDeldelDone(false)
                getData();
            }, 1000)
             

        } catch (err) {


            console.error("Delete failed:", err);

            let errorMessage = "Failed to delete the Sales Order!";
            if (err?.data?._server_messages) {
                try {
                    const messagesArray = JSON.parse(err.data._server_messages);
                    if (messagesArray && messagesArray.length > 0) {
                        // Parse the inner JSON object
                        const messageObj = JSON.parse(messagesArray[0]);
                        if (messageObj?.message) {
                            // Extract the exact message we want
                            const fullMessage = messageObj.message;

                            errorMessage = fullMessage.trim();
                            // Remove any trailing punctuation
                            errorMessage = errorMessage.replace(/<[^>]+>/g, '').trim();
                        }
                    }
                } catch (parseError) {
                    console.error("Error parsing server messages:", parseError);
                }
            }
            setDelPopupVisible(true);
            setDelmessage(errorMessage)
            setalredysubmitdata(true)

            // alert(errorMessage);
        } finally {
            // setDelPopupVisible(false);
            // setDelSelectedId(null);
        }
    };


    const activeFilterCount = useMemo(() => {
        return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
    }, [filters]);

    const actionButtons = [
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "IoFilterSharp",
            iconSize: 12,
            children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",

            onClick: () => {
                setShowFilters(prev => !prev);
                setShowColumnConfig(false);
            }
        },
        {
            className: "btnsecond border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "MdOutlineRemoveRedEye",
            iconSize: 12,
            children: "Show more",
            onClick: () => {
                setShowColumnConfig(prev => !prev);
                setShowFilters(false);
            }
        },
        {
            className: "btnthird border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel",
            onClick: () => setShowExportPopup(true),
        },
        {
            className: "custom-btn-00989 d-flex",
            to: "/outbound/outbound-create-sales-order",
            iconName: "FiPlus",
            style: { gap: '2px', height: '28px' },
            children: "Add Sales Order"
        }
    ];

    const getData = async () => {
        setLoading(true);
        try {
					const filteredSearchInput = Object.entries(filters).reduce(
						(acc, [key, value]) => {
							if (value !== "" && value !== undefined && value !== null) {
								acc[key] = value;
							}
							return acc;
						},
						{}
            );
           
					const siNoFilter = filteredSearchInput.siNo;
					const isSiNoFilterActive =
						siNoFilter !== undefined && siNoFilter !== "";
					// STEP 3: If filtering by siNo, jump to that page
					const targetPage = isSiNoFilterActive
						? Math.ceil(parseInt(siNoFilter, 10) / pageSize)
						: currentPage;
					const payload = {
						start: pageSize * (targetPage - 1),
						page_length: pageSize || 12,
						...(Object.keys(filteredSearchInput).length > 0 && {
							search_input: {
								sales_order_no: filteredSearchInput.name || "",
								customer: filteredSearchInput.customer || "",
								status: filteredSearchInput.status || "",
								date_range: filteredSearchInput.date_range || "",
								min_total_qty: filteredSearchInput.total_qty || "",
								max_total_qty: filteredSearchInput.total_qty || "",
								min_no_of_line: filteredSearchInput.no_of_line || "",
								max_no_of_line: filteredSearchInput.no_of_line || "",
								total_taxes: filteredSearchInput.total_taxes || "",
								grand_total: filteredSearchInput.grand_total || "",
								billing_address: filteredSearchInput.billing_address || "",
								shipping_address: filteredSearchInput.shipping_address || "",
								mobile_number: filteredSearchInput.mobile_number || "",
								customer_gstin: filteredSearchInput.customer_gstin || "",
								transaction_date: filteredSearchInput.transaction_date || "",
								place_of_supply: filteredSearchInput.place_of_supply || "",
								order_type: filteredSearchInput.order_type || "",
								net_total: filteredSearchInput.net_total || "",
							},
						}),
					};

			const response = await salesDataApi(payload);
            const rawData = response.data.data.sales_orders;
            // console.log("rawData",rawData)
					// STEP 4: Assign global serial numbers
					const numberedData = rawData.map((item, index) => ({
						...item,
						siNo: index + 1 + pageSize * (targetPage - 1),
					}));

					// STEP 5: If siNo is used, filter client-side
					const finalData = isSiNoFilterActive
						? numberedData.filter(
								(item) => item.siNo === parseInt(siNoFilter, 10)
						  )
						: numberedData;
					setSalesData({
						sales_orders: finalData,
						total_no_of_records: response.data.data.total_no_of_records,
					});
            // Optional: update currentPage to reflect jump
		        console.log("paze size fetch", pageSize);
            
					if (isSiNoFilterActive) setCurrentPage(targetPage);
				} catch (error) {
            console.error("Error fetching sales orders:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleFilterChange = (newFilters) => {
        setCurrentPage(1);
        setFilters(newFilters);
    };

    useEffect(() => {
        
        if (pageSize > 0) {
                
			getData();
        }
        
	}, [currentPage, filters, screenHeight, screenScaling, pageSize]);
    const accessors = [
        "name",
        "customer",
        // "no_of_line",
        "total_qty",
        "net_total",
        "total_taxes_and_charges",
        "grand_total",
        "order_type",
        "place_of_supply",
        "shipping_address",
        "customer_address",
        "contact_mobile",
        "customer_gstin",
        "status",
        "transaction_date"
    ]
    return (
        <div className="container-fluid d-flex flex-column" style={{ flexGrow: '1' }}>
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "Outbound" },
                    { label: "Sales Order List", style: { color: '#4b002b' } }
                ]}
                actionButtons={actionButtons}
            >
                {showFilters && (
                    <ListFilters
                        filtersConfig={filtersConfig}
                        onFilterChange={handleFilterChange}
                        currentFilters={filters}
                        setShowFilters={setShowFilters}
                    />
                )}

                {showColumnConfig && (
                    <ConfigureColumnsNew
                        show={showColumnConfig}
                        onClose={() => setShowColumnConfig(false)}
                        onSave={handleSaveColumns}
                        docType="Sales Order"
                        defaultSelected={defaultSelectedColumns}
                        fieldsData={columnsConfig.map(col => ({
                            fieldname: col.accessor,
                            label: col.name
                        }))}
                        disabledFields={["siNo", "name", "status", "transaction_date", "action",'creation']}
                    />
                )}

                <Table
                    columns={visibleColumns}
                    data={salesData.sales_orders}
                    loading={loading}
                />

                <Pagination
                    setCurrentPage={setCurrentPage}
                    pageSize={pageSize}
                    totalRecords={salesData.total_no_of_records}
                    currentPage={currentPage}
                    className="mt-2 pb-3"
                />

                {delPopupVisible &&
                    <DelConfirmPopup
                        alredysubmitdata={alredysubmitdata}
                        delSelectedId={delSelectedId}
                        visible={delPopupVisible}
                        message={delmessage}
                        onConfirm={delHandleConfirm}
                        onCancel={delHandleCancel}
                        delDone={delDone}
                    />}


                {showExportPopup && (
                    <ExportCSV
                        doctype="Sales Order"
                        fieldsData={accessors}
                        onClose={() => setShowExportPopup(false)}
                    />
                )}
            </ListLayout>
        </div>
    );
};

export default Lpntable;